import React, { useState, useEffect } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';
import NavRail from '../components/NavRail';

/* ============================================================
   UTILISATEURS — Backoffice bot memecoin Solana (V1)
   Look = mockup design-docs/Users.jsx (dark terminal, full-screen).
   Comportement = CRUD users réel (react-query + api.js), 100% préservé.
   ============================================================ */

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400;500;600;700;800&display=swap');
:root{--bg:#0a0b0e;--surface:#14161c;--surface2:#191c23;--border:#1f2329;--text:#e6e8ec;--text2:#8a8f98;
  --green:#00e08a;--red:#ff3b5c;--amber:#ffb020;--cyan:#22d3ee;}
.uk *{box-sizing:border-box;margin:0;padding:0}
.uk,.uk *{font-family:'JetBrains Mono',ui-monospace,monospace;}
.uk{background:var(--bg);color:var(--text);height:100vh;display:flex;overflow:hidden;font-size:13px;line-height:1.35;-webkit-font-smoothing:antialiased;}
.uk .sb{width:64px;flex:0 0 64px;border-right:1px solid var(--border);background:#0c0d11;display:flex;flex-direction:column;align-items:center;padding:14px 0;gap:6px;}
.uk .sb-logo{width:34px;height:34px;border-radius:8px;background:var(--red);color:#fff;display:flex;align-items:center;justify-content:center;font-weight:800;font-size:16px;margin-bottom:14px;box-shadow:0 0 14px rgba(255,59,92,.45);}
.uk .sb-item{width:40px;height:40px;border-radius:8px;display:flex;align-items:center;justify-content:center;color:var(--text2);cursor:pointer;position:relative;transition:all .12s;font-size:16px;border:none;background:transparent;}
.uk .sb-item:hover{background:var(--surface);color:var(--text);}
.uk .sb-item.on{background:var(--surface);color:var(--cyan);box-shadow:inset 2px 0 0 var(--cyan);}
.uk .sb-item .tip{position:absolute;left:52px;top:50%;transform:translateY(-50%);background:#000;border:1px solid var(--border);padding:4px 9px;border-radius:6px;font-size:11px;white-space:nowrap;opacity:0;pointer-events:none;transition:opacity .12s;z-index:50;color:var(--text);}
.uk .sb-item:hover .tip{opacity:1;}
.uk .sb-spacer{flex:1;}
.uk .main{flex:1;display:flex;flex-direction:column;overflow:hidden;}
.uk .top{display:flex;align-items:center;gap:18px;padding:11px 18px;border-bottom:1px solid var(--border);background:#0c0d11;flex:0 0 auto;}
.uk .top-title{font-size:14px;font-weight:800;letter-spacing:.04em;color:var(--text);}
.uk .top-spacer{flex:1;}.uk .clock{font-size:11px;color:var(--text2);text-align:right;}.uk .clock b{color:var(--text);font-weight:600;}
.uk .page{flex:1;overflow:auto;padding:16px;}
.uk .bar-row{display:flex;align-items:center;justify-content:space-between;margin-bottom:14px;}
.uk .h1{font-size:13px;letter-spacing:.16em;text-transform:uppercase;color:var(--text2);font-weight:600;}
.uk .invite{background:var(--cyan);color:#04181c;border:none;border-radius:9px;padding:9px 16px;font-weight:800;font-size:12px;letter-spacing:.03em;cursor:pointer;font-family:inherit;box-shadow:0 0 18px rgba(34,211,238,.25);transition:filter .12s;}
.uk .invite:hover{filter:brightness(1.1);}
.uk .invite.cancel{background:var(--surface2);color:var(--text);border:1px solid var(--border);box-shadow:none;}
.uk .strip{display:grid;grid-template-columns:repeat(4,1fr);gap:10px;margin-bottom:16px;}
@media(max-width:760px){.uk .strip{grid-template-columns:repeat(2,1fr);}}
.uk .kpi{background:var(--surface);border:1px solid var(--border);border-radius:10px;padding:11px 13px;}
.uk .kpi .k{font-size:9.5px;color:var(--text2);letter-spacing:.07em;text-transform:uppercase;}
.uk .kpi .v{font-size:20px;font-weight:800;margin-top:4px;}
.uk .kpi .v.cy{color:var(--cyan);}.uk .kpi .v.gr{color:var(--green);}
.uk .grid2{display:grid;grid-template-columns:1.6fr 1fr;gap:12px;}
@media(max-width:980px){.uk .grid2{grid-template-columns:1fr;}}
.uk .tbl-wrap{background:var(--surface);border:1px solid var(--border);border-radius:12px;overflow:hidden;}
.uk .tbl-hd{padding:12px 15px;border-bottom:1px solid var(--border);font-size:11px;letter-spacing:.14em;text-transform:uppercase;color:var(--text2);font-weight:600;}
.uk table{width:100%;border-collapse:collapse;}
.uk thead th{font-size:9px;letter-spacing:.09em;text-transform:uppercase;color:var(--text2);text-align:left;padding:8px 15px;font-weight:600;background:#0e1014;}
.uk tbody td{padding:11px 15px;font-size:12.5px;border-top:1px solid #16191f;vertical-align:middle;}
.uk tbody tr:hover{background:var(--surface2);}
.uk .u{display:flex;align-items:center;gap:10px;}
.uk .av{width:30px;height:30px;border-radius:8px;display:flex;align-items:center;justify-content:center;font-weight:800;font-size:12px;color:#0a0b0e;flex:0 0 30px;}
.uk .u .nm{font-weight:700;}.uk .u .em{font-size:10px;color:var(--text2);}
.uk .role{font-size:10px;font-weight:700;padding:3px 9px;border-radius:5px;letter-spacing:.03em;}
.uk .role.owner{background:rgba(255,59,92,.14);color:var(--red);}
.uk .role.admin{background:rgba(255,176,32,.15);color:var(--amber);}
.uk .role.op{background:rgba(34,211,238,.14);color:var(--cyan);}
.uk .role.view{background:rgba(138,143,152,.16);color:var(--text2);}
.uk .role-sel{background:#0a0b0e;border:1px solid var(--border);border-radius:6px;color:var(--text);font-size:11px;font-family:inherit;padding:4px 8px;cursor:pointer;outline:none;}
.uk .role-sel:focus{border-color:var(--cyan);}
.uk .stat-tag{font-size:9.5px;font-weight:700;padding:2px 8px;border-radius:5px;}
.uk .stat-tag.active{background:rgba(0,224,138,.14);color:var(--green);}
.uk .stat-tag.off{background:rgba(138,143,152,.16);color:var(--text2);}
.uk .muted{color:var(--text2);}
.uk .actions{display:flex;gap:8px;}
.uk .abtn{background:var(--surface2);border:1px solid var(--border);border-radius:6px;color:var(--text);font-size:10.5px;font-family:inherit;font-weight:600;padding:5px 10px;cursor:pointer;transition:all .12s;}
.uk .abtn:hover{border-color:var(--cyan);color:var(--cyan);}
.uk .card{background:var(--surface);border:1px solid var(--border);border-radius:12px;padding:14px;}
.uk .card-ti{font-size:11px;letter-spacing:.14em;text-transform:uppercase;color:var(--text2);font-weight:600;margin-bottom:12px;}
.uk .note{font-size:10px;color:var(--text2);line-height:1.6;}
.uk .ovl{position:fixed;inset:0;background:rgba(0,0,0,.72);backdrop-filter:blur(3px);display:flex;align-items:center;justify-content:center;z-index:100;}
.uk .modal{width:430px;max-width:92vw;background:var(--surface);border:1px solid var(--border);border-radius:13px;padding:22px;box-shadow:0 20px 60px rgba(0,0,0,.6);}
.uk .modal h2{font-size:16px;font-weight:800;margin-bottom:16px;}
.uk .flabel{font-size:9.5px;letter-spacing:.12em;text-transform:uppercase;color:var(--text2);font-weight:600;margin:0 0 6px;}
.uk .inp{width:100%;background:#0a0b0e;border:1px solid var(--border);border-radius:9px;padding:11px 12px;color:var(--text);font-size:13px;font-family:inherit;outline:none;margin-bottom:14px;}
.uk .inp:focus{border-color:var(--cyan);}
.uk .roles-pick{display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-bottom:18px;}
.uk .rp{border:1px solid var(--border);border-radius:9px;padding:9px 11px;cursor:pointer;font-size:11px;transition:all .12s;background:transparent;text-align:left;color:var(--text);font-family:inherit;}
.uk .rp.on{border-color:var(--cyan);background:rgba(34,211,238,.08);}
.uk .rp b{display:block;font-size:12px;margin-bottom:2px;}.uk .rp span{color:var(--text2);font-size:10px;}
.uk .mbtns{display:flex;gap:10px;}
.uk .btn{flex:1;padding:12px;border-radius:9px;font-weight:700;font-size:13px;cursor:pointer;border:none;font-family:inherit;}
.uk .btn.cancel{background:var(--surface2);color:var(--text);border:1px solid var(--border);}
.uk .btn.confirm{background:var(--cyan);color:#04181c;}
.uk .btn.confirm:disabled{opacity:.5;cursor:not-allowed;}
.uk .ferr{color:var(--red);font-size:11.5px;margin-bottom:12px;font-weight:600;}
.uk .toast{position:fixed;bottom:24px;left:50%;transform:translateX(-50%);background:var(--cyan);color:#04181c;font-weight:800;font-size:13px;padding:12px 22px;border-radius:10px;z-index:110;box-shadow:0 10px 34px rgba(34,211,238,.35);}
.uk .denied{flex:1;display:flex;align-items:center;justify-content:center;color:var(--red);font-weight:700;font-size:14px;letter-spacing:.04em;}
.uk .loading{color:var(--text2);padding:24px;font-size:12.5px;}
`;

// Rôles réels du backend (cf. UsersPage CRUD + select existant : viewer / trader / admin).
const ROLE_META = {
  admin: { cls: 'admin', label: 'Admin' },
  trader: { cls: 'op', label: 'Trader' },
  viewer: { cls: 'view', label: 'Viewer' },
};
// Couleurs avatar dérivées du rôle (placeholder mockup `color` sans équivalent réel).
const ROLE_COLOR = { admin: '#ffb020', trader: '#22d3ee', viewer: '#8a8f98' };
// Pickers du formulaire de création (mappés sur les rôles réels acceptés par POST /users).
const ROLE_PICK = [
  { id: 'viewer', b: 'Viewer', s: 'consultation seule' },
  { id: 'admin', b: 'Admin', s: 'gère users + contrôles' },
];

function UsersPage() {
  const { user } = useAuth();
  const queryClient = useQueryClient();
  const [showAddForm, setShowAddForm] = useState(false);
  const [newUser, setNewUser] = useState({ username: '', password: '', role: 'viewer' });
  const [formError, setFormError] = useState('');
  const [toast, setToast] = useState('');
  const [clock, setClock] = useState(new Date());

  useEffect(() => {
    const i = setInterval(() => setClock(new Date()), 1000);
    return () => clearInterval(i);
  }, []);

  const { data: users = [], isLoading } = useQuery({
    queryKey: ['users'],
    queryFn: () => api.get('/users').then(r => r.data),
    enabled: user?.role === 'admin',
  });

  const flash = (msg) => { setToast(msg); setTimeout(() => setToast(''), 3000); };

  const createUser = useMutation({
    mutationFn: (data) => api.post('/users', data).then(r => r.data),
    onSuccess: () => {
      queryClient.invalidateQueries(['users']);
      setShowAddForm(false);
      setNewUser({ username: '', password: '', role: 'viewer' });
      setFormError('');
      flash('✓ Utilisateur créé');
    },
    onError: (err) => setFormError(err.response?.data?.detail || 'Failed to create user'),
  });

  const updateUser = useMutation({
    mutationFn: ({ id, data }) => api.put(`/users/${id}`, data).then(r => r.data),
    onSuccess: () => queryClient.invalidateQueries(['users']),
  });

  const resetPassword = useMutation({
    mutationFn: ({ id, password }) => api.post(`/users/${id}/reset-password`, { password }).then(r => r.data),
    onSuccess: () => flash('✓ Mot de passe réinitialisé'),
    onError: (err) => alert(err.response?.data?.detail || 'Failed to reset password'),
  });

  const handleAddSubmit = (e) => {
    e.preventDefault();
    setFormError('');
    createUser.mutate(newUser);
  };
  const handleRoleChange = (userId, role) => updateUser.mutate({ id: userId, data: { role } });
  const handleToggleActive = (userId, isActive) => updateUser.mutate({ id: userId, data: { is_active: !isActive } });
  const handleResetPassword = (userId) => {
    const password = prompt('Nouveau mot de passe :');
    if (password) resetPassword.mutate({ id: userId, password });
  };

  const t = clock.toLocaleTimeString('fr-FR', { hour12: false });

  // Side-rail (canonique, item Users = on). Toujours rendu.
  const rail = <NavRail />;

  // Restriction admin réelle préservée.
  if (user?.role !== 'admin') {
    return (
      <div className="uk">
        <style>{CSS}</style>
        {rail}
        <div className="main">
          <div className="top"><span className="top-title">Utilisateurs & accès</span></div>
          <div className="denied">Accès refusé — privilèges Admin requis.</div>
        </div>
      </div>
    );
  }

  const total = users.length;
  const activeCount = users.filter(u => u.is_active).length;
  const adminCount = users.filter(u => u.role === 'admin').length;

  return (
    <div className="uk">
      <style>{CSS}</style>
      {rail}
      <div className="main">
        <div className="top">
          <span className="top-title">Utilisateurs & accès</span>
          <div className="top-spacer" />
          <div className="clock"><b>{t}</b><br />Connecté : {user?.username || '—'}</div>
        </div>

        <div className="page">
          <div className="bar-row">
            <span className="h1">Utilisateurs & accès</span>
            <button
              className={`invite${showAddForm ? ' cancel' : ''}`}
              onClick={() => { setShowAddForm(s => !s); setFormError(''); }}
            >
              {showAddForm ? 'Annuler' : '+ Ajouter'}
            </button>
          </div>

          <div className="strip">
            <div className="kpi"><div className="k">Utilisateurs</div><div className="v">{total}</div></div>
            <div className="kpi"><div className="k">Actifs</div><div className="v gr">{activeCount}</div></div>
            <div className="kpi"><div className="k">Admins</div><div className="v cy">{adminCount}</div></div>
            <div className="kpi"><div className="k">Inactifs</div><div className="v">{total - activeCount}</div></div>
          </div>

          <div className="grid2">
            <div className="tbl-wrap">
              <div className="tbl-hd">Membres</div>
              {isLoading ? (
                <div className="loading">Chargement des utilisateurs…</div>
              ) : (
                <div style={{ overflowX: 'auto' }}>
                  <table>
                    <thead>
                      <tr>
                        <th>Utilisateur</th><th>Rôle</th><th>Créé le</th><th>Statut</th><th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {users.map(u => {
                        return (
                          <tr key={u.id}>
                            <td>
                              <div className="u">
                                <span className="av" style={{ background: ROLE_COLOR[u.role] || '#8a8f98' }}>
                                  {(u.username || '?')[0].toUpperCase()}
                                </span>
                                <span><span className="nm">{u.username}</span></span>
                              </div>
                            </td>
                            <td>
                              <select
                                className="role-sel"
                                value={u.role}
                                onChange={e => handleRoleChange(u.id, e.target.value)}
                              >
                                <option value="viewer">Viewer</option>
                                <option value="trader">Trader</option>
                                <option value="admin">Admin</option>
                              </select>
                            </td>
                            <td className="muted">
                              {u.created_at ? new Date(u.created_at).toLocaleDateString('fr-FR') : '—'}
                            </td>
                            <td>
                              <span className={`stat-tag ${u.is_active ? 'active' : 'off'}`}>
                                {u.is_active ? 'actif' : 'désactivé'}
                              </span>
                            </td>
                            <td>
                              <div className="actions">
                                <button className="abtn" onClick={() => handleToggleActive(u.id, u.is_active)}>
                                  {u.is_active ? 'Désactiver' : 'Activer'}
                                </button>
                                <button className="abtn" onClick={() => handleResetPassword(u.id)}>
                                  Reset mdp
                                </button>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                      {users.length === 0 && (
                        <tr>
                          <td colSpan={5} style={{ padding: '24px', textAlign: 'center', color: 'var(--text2)' }}>
                            Aucun utilisateur
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>

            <div className="card">
              <div className="card-ti">Rôles & accès</div>
              <div style={{ marginBottom: 12 }}>
                {Object.entries(ROLE_META).map(([id, m]) => (
                  <div key={id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '7px 0' }}>
                    <span className={`role ${m.cls}`}>{m.label}</span>
                    <span className="note" style={{ flex: 1 }}>
                      {id === 'admin' ? 'gère les utilisateurs + tous les contrôles'
                        : id === 'trader' ? 'opérations trading'
                        : 'consultation seule'}
                    </span>
                  </div>
                ))}
              </div>
              <div className="note" style={{ borderTop: '1px solid #16191f', paddingTop: 11 }}>
                La gestion des utilisateurs (création, rôle, activation, reset mot de passe)
                est réservée au rôle Admin. Les actions sensibles côté trading restent gérées
                depuis le Cockpit.
              </div>
            </div>
          </div>
        </div>
      </div>

      {showAddForm && (
        <div className="ovl" onClick={() => { setShowAddForm(false); setFormError(''); }}>
          <form className="modal" onClick={(e) => e.stopPropagation()} onSubmit={handleAddSubmit}>
            <h2>Ajouter un utilisateur</h2>
            {formError && <div className="ferr">{formError}</div>}
            <div className="flabel">Nom d'utilisateur</div>
            <input
              className="inp"
              type="text"
              required
              placeholder="username"
              value={newUser.username}
              onChange={e => setNewUser(p => ({ ...p, username: e.target.value }))}
            />
            <div className="flabel">Mot de passe</div>
            <input
              className="inp"
              type="password"
              required
              placeholder="••••••••"
              value={newUser.password}
              onChange={e => setNewUser(p => ({ ...p, password: e.target.value }))}
            />
            <div className="flabel">Rôle</div>
            <div className="roles-pick">
              {ROLE_PICK.map(r => (
                <button
                  type="button"
                  key={r.id}
                  className={`rp ${newUser.role === r.id ? 'on' : ''}`}
                  onClick={() => setNewUser(p => ({ ...p, role: r.id }))}
                >
                  <b>{r.b}</b><span>{r.s}</span>
                </button>
              ))}
            </div>
            <div className="mbtns">
              <button type="button" className="btn cancel" onClick={() => { setShowAddForm(false); setFormError(''); }}>Annuler</button>
              <button type="submit" className="btn confirm" disabled={createUser.isPending}>
                {createUser.isPending ? 'Création…' : 'Créer'}
              </button>
            </div>
          </form>
        </div>
      )}
      {toast && <div className="toast">{toast}</div>}
    </div>
  );
}

export default UsersPage;
